"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductInventory = void 0;
const product_1 = require("./product");
const getProductInventory = (product, selectedVariantId = null, blockInventory = 0) => {
    const { continueSellingOutOfStock, isInventoryEnabled, inventory = 0, variants, availability, minimumOrderQuantity, } = product;
    const { items = [] } = variants || {};
    const moq = minimumOrderQuantity || 1;
    if (isInventoryEnabled) {
        if (!continueSellingOutOfStock) {
            if (items.length) {
                if (!selectedVariantId) {
                    const { firstVariant } = (0, product_1.getProductMeta)(product);
                    const { inventory: variantInventory } = firstVariant || {};
                    const currentInventory = Math.max(0, (variantInventory || 0) - (blockInventory || 0));
                    return {
                        hasInventory: !!currentInventory && currentInventory >= moq,
                        currentInventory,
                    };
                }
                else {
                    const selectedVariant = items.find((s) => s.id === selectedVariantId);
                    const { inventory: variantInventory } = selectedVariant || {};
                    const currentInventory = Math.max(0, (variantInventory || 0) - (blockInventory || 0));
                    return {
                        hasInventory: !!currentInventory && currentInventory >= moq,
                        currentInventory,
                    };
                }
            }
            else {
                const currentInventory = Math.max(0, (inventory || 0) - (blockInventory || 0));
                return {
                    hasInventory: !!currentInventory && currentInventory >= moq,
                    currentInventory,
                };
            }
        }
    }
    return {
        hasInventory: !availability || availability === "in stock",
        currentInventory: 99,
    };
};
exports.getProductInventory = getProductInventory;
